<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm7 md4 lg3 xl3>
        <v-card flat class="elevation-5">
          <v-card-title>
            <h2 class="font-weight-light">
              Вход в систему
            </h2>
          </v-card-title>
          <v-card-text class="pt-5 mt-5">
            <v-form ref="form">
              <v-text-field
              autocomplete
              name="login"
              v-model="schooladminid"
              type="text"
              label="логин"
              required
              outlined
              append-icon="account_circle"
              @keyup.enter="$refs.ipassword.focus"
              ></v-text-field>
              <v-text-field
              autocomplete
              name="password"
              ref="ipassword"
              v-model="password"
              label="пароль"
              type="password"
              required
              outlined
              append-icon="lock"
              ></v-text-field>
              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
              <br />
              <v-btn outlined block large color="primary" @click="login" :disabled="!valid">
                Продолжить
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'login',
  data: () => ({
    schooladminid: null,
    password: null,
  }),
  computed: {
    validLogin () {
      if (!this.schooladminid) return false
      if (this.schooladminid.length < 6) return false
      return true
    },
    validPassword () {
      if (!this.password) return false
      if (this.password.length < 6) return false
      return true
    },
    valid () {
      return this.validLogin && this.validPassword
    }
  },
  methods: {
    async login () {
      try {
        if (!this.valid) return
        const resetkey = this.resetkey
        const schooladminid = this.schooladminid
        const password = this.password
        this.$store.dispatch('login', { schooladminid, password, resetkey })
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    restorePassword () {
      this.$store.dispatch('sioRequest', {
        topic: 'auth-reset-password',
        pl: {
          schooladminid: this.schooladminid,
          domain: this.$store.state.domain,
          scope: 'schooladmins'
        }
      }).then((result) => {
        this.$store.dispatch('snack', result.meta.msg)
        this.restoreBlocked = true
      }).catch(err => {
        this.$store.dispatch('snack', err)
      })
    }
  }
}
</script>
